export default {
  DRAFT_SELL: 'DRAFT_SELL',
  DRAFT_SAFE: 'DRAFT_SAFE',
  DRAFT_BUY_SELL_SHARES: 'DRAFT_BUY_SELL_SHARES',
  DRAFT_CAPITAL_INCREASE: 'DRAFT_CAPITAL_INCREASE',
  DRAFT_CONVERTIBLE_NOTE: 'DRAFT_CONVERTIBLE_NOTE',
};
